import React, { Component } from 'react'
import { ScrollButtonStyle } from './style'
import { Icon } from '../Icon'
import { connect } from 'react-redux'

class ScrollButton extends Component {
	constructor(props) {
		super(props)
		this.timeOut = null
	}

	scrollDown = () => {
		window.scrollTo({
			top: window.scrollY + 33,
			behavior: 'smooth',
		})
	}

	handleScrollStart = () => {
		if (!this.timeOut) {
			this.timeOut = setInterval(this.scrollDown, 100)
		}
	}

	handleScrollStop = () => {
		if (this.timeOut) {
			clearInterval(this.timeOut)
			this.timeOut = null
		}
	}

	render() {
		let { visibility } = this.props
		return (
			<ScrollButtonStyle
				onMouseDown={this.handleScrollStart}
				onMouseUp={this.handleScrollStop}
				onTouchStart={this.handleScrollStart}
				onTouchEnd={this.handleScrollStop}
				onMouseOut={this.handleScrollStop}
				visibility={visibility}
				{...this.props}
			>
				<Icon component='arrowDown' />
			</ScrollButtonStyle>
		)
	}
}

function mapStateToProps({ scrollButton }) {
	return {
		...scrollButton,
	}
}

export default connect(mapStateToProps)(ScrollButton)
